<template lang="pug">
.container-tabs
  ul(class='tabs')
    li(
      v-for="(tab, index) in tabs"
      :key="index"
      :class="['tab-item', activeIndex === index && 'active']"
      @click="selectTab(index)"
    )
      span.icon(v-if="tab.icon && tab.icon.component")
        component(:is="tab.icon.component" v-bind="iconProps(tab.icon)")
      span.label {{ tab.label }}
</template>

<script>
export default {
  name: 'Tabs',
  props: {
    tabs: {
      type: Array,
      required: true
    },
    defaultActive: {
      type: Number,
      default: 0
    }
  },
  data() {
    return {
      activeIndex: this.defaultActive
    }
  },
  mounted() {
    this.setActiveTabFromRoute()
  },
  watch: {
    '$route.fullPath': {
      immediate: true,
      handler() {
        this.setActiveTabFromRoute()
      }
    }
  },
  methods: {
    setActiveTabFromRoute() {
      const currentPath = this.$route.fullPath

      const foundIndex = this.tabs.findIndex(tab =>
        currentPath.endsWith(tab.rota)
      )

      if (foundIndex !== -1) {
        this.activeIndex = foundIndex
      }
    },
    selectTab(index) {
      this.activeIndex = index
      this.$emit('change', index)
    },
    iconProps(icon) {
      const { component, ...props } = icon
      return props
    }
  }
}
</script>

<style lang="scss" scoped>
.container-tabs {
  border: 1px solid $borderColor;
  border-radius: 6px;
  overflow: hidden;
  background: $corFundoPadraoDashboard;
  width: 100%;
  height: 40px;

  ul.tabs {
    display: flex;
    list-style: none;
    margin: 0;
    padding: 0;
    height: 100%;

    .tab-item {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      gap: 6px;
      height: 32px;
      margin: 4px;
      border-radius: 6px;
      padding: 0 12px;
      font-size: 14px;
      font-weight: 500;
      color: $corValueInfoContato;
      cursor: pointer;
      transition: all 0.2s ease;

      &.active {
        background: $corVerdeClaro;
        color: $corPreto;

        .icon {
          color: $corPreto;;
        }
      }

      .icon {
        display: flex;
        align-items: center;
        justify-content: center;
      }

      .label {
        display: inline-block;
      }
    }
  }

  @media (max-width: 640px) {
    ul.tabs{
      li.tab-item {
        .label {
          display: none;
        }
      }
    }
  }
}

</style>
